let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('6blyj') + "betweenness.19722fdc.js";module.exports = workerURL(url, bundleURL.getOrigin(url), true);